import {Injectable} from '@angular/core'
import {Observable, Subject} from 'rxjs'

@Injectable({
    providedIn: 'root'
})
export class LoadingService {

    private loadSource: Subject<boolean> = new Subject<boolean>()
    public $load: Observable<boolean> = new Observable<boolean>()

    private timer

    constructor() {
        this.$load = this.loadSource.asObservable()
    }

    show() {
        if (this.timer) {
            clearTimeout(this.timer)
        }
        this.loadSource.next(true)
    }

    hide() {
        this.loadSource.next(false)
        if (this.timer) {
            clearTimeout(this.timer)
        }
    }
}
